package com.macrofocus.common.collection

@JsExport
class JsArrayList<E>(vararg elements: E) : ArrayList<E>(elements.toList()) {
}